import { useParams } from "react-router-dom";
import TranslatorViewLite from "./../components/TranslatorViewLite.react";

export default function TranslatorViewLiteRoute(): React$Element<any> {
  let params = useParams();
  return <TranslatorViewLite sessionId={params.sessionId} />;
}
